export interface StatusMeta {
  label: string;
  className: string;
}

export const EDITION_LABELS: Record<string, string> = {
  standard: "标准版",
  professional: "专业版",
  enterprise: "企业版",
};

export function editionLabel(key: string | null | undefined): string {
  if (!key) return "--";
  return EDITION_LABELS[key] ?? key;
}

// 许可证来源：审批发证（走授权申请）或自助核销（用原始激活码换取）。
export const LICENSE_SOURCE_META: Record<string, { label: string; className: string; icon: string }> = {
  application: {
    label: "审批发证",
    className: "bg-secondary-100 text-secondary-900",
    icon: "ri-file-check-line",
  },
  redeem: {
    label: "用激活码核销",
    className: "bg-accent-100 text-accent-900",
    icon: "ri-gift-2-line",
  },
};

export function licenseSourceMeta(source: string | null | undefined) {
  return LICENSE_SOURCE_META[source ?? ""] ?? LICENSE_SOURCE_META.application;
}

export const LICENSE_STATUS_META: Record<string, StatusMeta> = {
  active: { label: "有效", className: "bg-primary-100 text-primary-700" },
  expired: { label: "已过期", className: "bg-secondary-100 text-secondary-900" },
  suspended: { label: "已暂停", className: "bg-accent-100 text-accent-700" },
  revoked: { label: "已吊销", className: "bg-accent-100 text-accent-800" },
};

export const APPLICATION_STATUS_META: Record<string, StatusMeta> = {
  pending: { label: "待审批", className: "bg-accent-100 text-accent-700" },
  approved: { label: "已通过", className: "bg-primary-100 text-primary-700" },
  rejected: { label: "已驳回", className: "bg-secondary-100 text-secondary-900" },
};

export const ROLE_LABELS: Record<string, string> = {
  customer: "普通用户",
  admin: "管理员",
};